import type { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'
import { httpClient } from './httpClient'
import type { ApiResponse, ApiError } from '@/types'
import { ERROR_MESSAGES } from '@/data/constants'

export const api = {
  get: <T = unknown>(url: string, params?: unknown): Promise<AxiosResponse<ApiResponse<T>>> => {
    return httpClient.get(url, { params })
  },

  post: <T = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<AxiosResponse<ApiResponse<T>>> => {
    return httpClient.post(url, data, config)
  },

  put: <T = unknown>(url: string, data?: unknown): Promise<AxiosResponse<ApiResponse<T>>> => {
    return httpClient.put(url, data)
  },

  patch: <T = unknown>(url: string, data?: unknown): Promise<AxiosResponse<ApiResponse<T>>> => {
    return httpClient.patch(url, data)
  },

  delete: <T = unknown>(url: string): Promise<AxiosResponse<ApiResponse<T>>> => {
    return httpClient.delete(url)
  },
}

export const handleApiError = (error: AxiosError<ApiError>): string => {
  if (error.response?.data?.message) {
    return error.response.data.message
  }
  
  if (error.message) {
    return error.message
  }
  
  return ERROR_MESSAGES.UNKNOWN_ERROR
}

export const isApiError = (error: unknown): error is AxiosError<ApiError> => {
  return (error as AxiosError)?.isAxiosError === true
}